import { render, staticRenderFns } from "./GroupEditDetails.vue?vue&type=template&id=190fda56&scoped=true&lang=html&"
import script from "./GroupEditDetails.vue?vue&type=script&lang=js&"
export * from "./GroupEditDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190fda56",
  null
  
)

export default component.exports